import { Alert, Button, Layout, message, Modal, Space, Spin, Tree } from 'antd';
import { observer } from 'mobx-react';
import { useCallback, useEffect, useRef, useState } from 'react';
import error from '../../../assets/error.png';
import success from '../../../assets/success.png';
import { baseURL, get } from '../../../axios/axios';
import styles from './index.module.scss';

import {
    LeftOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    RightOutlined,
} from '@ant-design/icons';
import useCountdown from '@bradgarropy/use-countdown';
import { Checkbox } from 'antd';
import { globalData } from '../../../Service/utils';
import { summaryStore } from '../store';

import { useModal } from '@ebay/nice-modal-react';
import bgcc from '../../../assets/slider-bgcc.svg';
import ckwx from '../../../assets/slider-ckwx.svg';
import word from '../../../assets/slider-word.svg';
import zy from '../../../assets/slider-zy.svg';
import AiGenTip from '../../../components/aiGenTip';
import { useDevice } from '../../../hooks/useDevice';
import { loginInstance } from '../../../Service/login';
import { DocType } from '../const';
import CountdownProgress from './components/CountdownProgress';
import { DownloadPaperModal } from './components/DownloadPaperModal';
import RedeemModal from './components/RedeemModal';
import SummaryDrawer from './components/SummaryDrawer';
import UnlockAllChapterModal from './components/UnlockAllChapterModal/index';
import useAbstract from './hooks/useAbstract';
import kf from '../../../assets/kf.png';
import { isAmountEntitlement, selectPackageEntitlement, useSelectedPackageEntitlement } from '../../../Service/packageEntitlements';
import GroupBuyingOrder from '../../../components/GroupBuyingOrder/GroupBuyingOrder';
const { Sider, Content } = Layout;

const auth = loginInstance.getHeaders();
const authHeaders = auth ? { Authorization: auth } : {};

export const Step3 = observer(() => {
    const useRedeemModal = useModal(RedeemModal);
    const usePackageOrders = useModal(GroupBuyingOrder);
    const selectedEntitlement = useSelectedPackageEntitlement();
    const useSummaryDrawer = useModal(SummaryDrawer);
    const useDownloadPaperModal = useModal(DownloadPaperModal);

    const [paper, setPaper] = useState(summaryStore.paperInfo || {});
    const [payResult, setPayResult] = useState(false); // 支付结果
    const [loading, setLoading] = useState(false);

    // 修改大纲弹窗逻辑
    const updateOutlineCallback = useCallback(async () => {
        await summaryStore.updateOutline();
        message.success('修改成功');
    }, []);
    const showDrawer = useCallback((e) => {
        e?.stopPropagation();
        useSummaryDrawer.show({
            onConfirm: updateOutlineCallback,
        });
    }, []);

    // 我有兑换码弹窗
    const showCodeModal = async (e) => {
        e?.stopPropagation();
        useRedeemModal
            .show({
                orderNo: paper.orderNo,
            })
            .then((res) => {
                console.log('showCodeModal', res);
                // 如果是通过兑换码解锁的全篇
                // if (res?.services) {
                //     summaryStore.setServiceListByStype(res.services.map((it) => it.stype));
                // }
                setPayResult(true);
                setTimeout(() => {
                    countdownProgressRef.current?.startCountdown();
                }, 1000);
            })
            .catch((res) => {
                console.log('showCodeModal catch', res);
            });
    };

    // 中文摘要流
    const {
        abstracts: cnAbstracts,
        abstractsCompleted: cnAbstractsCompleted,
        streamLoading: cnStreamLoading,
        streamRequest: cnStreamRequest,
        reset: cnReset,
    } = useAbstract({
        baseURL,
        authHeaders,
        url: 'ai/ai/paper/gen/c/abstract',
    });
    useEffect(() => {
        cnStreamRequest({
            orderNo: paper.orderNo,
        });
    }, []);

    // 英文摘要流
    const {
        abstracts: enAbstracts,
        abstractsCompleted: enAbstractsCompleted,
        streamLoading: enStreamLoading,
        streamRequest: enStreamRequest,
        reset: enReset,
    } = useAbstract({
        baseURL,
        authHeaders,
        url: 'ai/ai/paper/gen/e/abstract',
    });

    useEffect(() => {
        if (cnAbstractsCompleted) {
            console.log('cnAbstracts', cnAbstracts);
            enStreamRequest({
                orderNo: paper.orderNo,
            });
        }
    }, [cnAbstractsCompleted]);

    // 处理继续预览
    const handleContinuePreview = useCallback(async () => {
        await summaryStore.getFinalPriview();
    }, [summaryStore]);

    const countdownProgressRef = useRef(null);
    const [generateFinish, setGenerateFinish] = useState(false);

    // 解锁全篇
    const useUnlockAllChapterModal = useModal(UnlockAllChapterModal);
    const unlockAllChapter = () => {
        if (!summaryStore.isCheckConfirm) {
            message.info('请先阅读并同意服务条款');
            return;
        }
        if (selectedEntitlement && selectedEntitlement.codeType !== 1) {
            showCodeModal();
            return;
        }
        useUnlockAllChapterModal
            .show({
                orderNo: paper.orderNo,
            })
            .then((res) => {
                // 如果是通过兑换码解锁的全篇
                // if (res?.services) {
                //     summaryStore.setServiceListByStype(res.services.map((it) => it.stype));
                // }
                console.log('外部unlockAllChapter完成--->res', res);
                setPayResult(true);
                setTimeout(() => {
                    countdownProgressRef.current?.startCountdown();
                }, 1000);
            })
            .catch((res) => {
                console.log('unlockAllChapter catch', res);
            });
    };

    // 进行全文下载
    const showOrderModal = () => {
        useDownloadPaperModal.show({
            orderNo: paper.orderNo,
            queryType: 'query',
        });
    };

    function getHtmlContent(text) {
        if (!text) return '';
        // 1. 处理 [[citation:数字]] 格式（来自ExpansionModal等场景）
        let processedText = text.replace(/\[\[citation:(\d+)\]\]/g, '<sup>[$1]</sup>');

        // 1. 处理引用标记·
        processedText = processedText.replace(/\\ccccc\{\[(\d+)\]\}/g, '<span>[$1]</span>');

        // 2. 处理markdown加粗格式 - 匹配 **文字** 的模式
        processedText = processedText.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');

        // 3. 处理markdown标题格式 - 匹配 ### 文字 的模式
        // processedText = processedText.replace(/###\s+([^\n]+)/g, '<strong>$1</strong>');

        return processedText;
    }

    const countdown = useCountdown({
        minutes: 0,
        seconds: 60 * 60,
        format: 'mm:ss',
        autoStart: false,
        onCompleted: () => console.log('onCompleted'),
    });

    useEffect(() => {
        (async () => {
            await summaryStore.getCatalogueData();
        })();
    }, []);

    const siderStyle = {
        overflow: 'auto',
        height: 'calc(100vh - 56px)',
        position: 'fixed',
        top: 0,
        bottom: 0,
        scrollbarWidth: 'thin',
        scrollbarGutter: 'stable',
        backgroundColor: '#fff',
    };

    const [collapsed, setCollapsed] = useState(false);

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };
    // 展开/收起按钮样式
    const toggleButtonStyle = {
        position: 'absolute',
        right: '-16px',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '32px',
        height: '32px',
        backgroundColor: '#fff',
        border: '1px solid #EEEEF1',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 100,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    };

    const { isMobile } = useDevice();

    const [mobileCatalogueOpen, setMobileCatalogueOpen] = useState(false);
    const Catalogue = () => {
        return (
            <Tree
                defaultExpandAll={summaryStore.catalogueDataLoaded}
                showLine={false}
                showIcon={false}
                treeData={summaryStore.catalogueData}
            />
        );
    };

    const TOTAL_TIME = 60 * 60;
    const [timeLeft, setTimeLeft] = useState(TOTAL_TIME);
    const [isRunning, setIsRunning] = useState(false);

    const progress = ((TOTAL_TIME - timeLeft) / TOTAL_TIME) * 100;

    useEffect(() => {
        let timer;
        if (isRunning && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev <= 1) {
                        clearInterval(timer);
                        setIsRunning(false);
                        setGenerateFinish(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => timer && clearInterval(timer);
    }, [isRunning, timeLeft]);

    useEffect(() => {
        if (payResult && !generateFinish && !isRunning) {
            setTimeLeft(TOTAL_TIME);
            setTimeout(() => {
                setIsRunning(true);
            }, 1000);
        }
    }, [payResult, generateFinish]);

    // 过滤当前docType的附加服务列表
    const filterServiceList = () => {
        // 如果是开题报告，过滤掉开题报告
        if (summaryStore.docType === DocType.PROPOSAL_REPORT) {
            return summaryStore.serviceList.filter((service) => service?.sname !== '开题报告');
        }
        // 如果是文献综述，过滤掉文献综述
        if (summaryStore.docType === DocType.LITERATURE_REVIEW) {
            return summaryStore.serviceList.filter((service) => service?.sname !== '文献综述');
        }
        return summaryStore.serviceList;
    };

    const ExtraContent = observer(() => {
        return (
            <>
                <div className="font-sans">
                    {/* 标题 */}
                    <h1 className="mb-3 text-[16px] text-primary">您将获得</h1>

                    {/* 正文项目 - 蓝色边框 */}
                    <div className="mb-3 flex items-center rounded-lg border border-[#EEEEF1] p-4">
                        <div className="mr-3 h-6 w-6">
                            <img src={word} alt="" />
                        </div>
                        <div className="flex flex-1 items-center justify-between">
                            <span className="text-[14px] text-[#192038]">无限AI改稿</span>
                        </div>
                    </div>

                    {/* 中英文摘要 - 灰色边框 */}
                    <div className="mb-3 flex items-center rounded-lg border border-[#EEEEF1] p-4">
                        <div className="mr-3 h-6 w-6">
                            <img src={zy} alt="" />
                        </div>
                        <div className="flex flex-1 items-center justify-between">
                            <span className="text-[14px] text-[#192038]">一键降重</span>
                            <span className="text-[14px] text-[#192038] opacity-50"></span>
                        </div>
                    </div>

                    {/* 中英参考文献 - 灰色边框 */}
                    <div className="mb-3 flex items-center rounded-lg border border-[#EEEEF1] p-4">
                        <div className="mr-3 h-6 w-6">
                            <img src={ckwx} alt="" />
                        </div>
                        <div className="flex flex-1 items-center justify-between">
                            <span className="text-[14px] text-[#192038]">正文AI插入图表</span>
                        </div>
                    </div>
                    <div className="mb-3 flex items-center rounded-lg border border-[#EEEEF1] p-4">
                        <div className="mr-3 h-6 w-6">
                            <img src={bgcc} alt="" />
                        </div>
                        <div className="flex flex-1 items-center justify-between">
                            <span className="text-[14px] text-[#192038]">包过查重</span>
                        </div>
                    </div>
                </div>
                {summaryStore.serviceList && summaryStore.serviceList.length > 0 ? (
                    // enAbstractsCompleted &&
                    // cnAbstractsCompleted &&
                    // summaryStore.hasPreviewEnd ? (
                    <Spin
                        spinning={
                            summaryStore.isExtraloading ||
                            enStreamLoading ||
                            cnStreamLoading ||
                            summaryStore.nextPreviewLoading
                        }
                    >
                        <div className={`${styles.title} text-primary`}>附加服务</div>
                        <div className={styles.extraBox}>
                            {/* 新附加服务 */}
                            {/* zw_aigc gzd_aigc wf_aigc wp_aigc */}
                            {filterServiceList()
                                .filter((service) => service?.stype?.split('_')?.[1] === 'aigc')
                                .map((service) => (
                                    <div
                                        key={service.id}
                                        className={`${styles.extra} ${
                                            service.checked && styles.active
                                        } ${styles.newService}`}
                                    >
                                        <div style={{ position: 'relative' }}>
                                            <div className={styles.name}>
                                                {service.sname}
                                                <span className="ml-1 text-red-500">🔥</span>
                                            </div>
                                            {/* <div className={styles.desc}>
                                                <span className={styles.price}>
                                                    {service.price}元
                                                </span>
                                                <span className={styles.origin}>
                                                    {service.price2}元
                                                </span>
                                            </div> */}
                                        </div>
                                        <Checkbox
                                            disabled={payResult}
                                            style={{ position: 'relative' }}
                                            checked={service.checked}
                                            onChange={(e) => {
                                                summaryStore.onServiceCheck(
                                                    e.target.checked,
                                                    service.stype,
                                                );
                                                summaryStore.getPriceAfterAddServices();
                                            }}
                                        />
                                    </div>
                                ))}
                            {/* 原附加服务 */}
                            {filterServiceList()
                                .filter((service) => service?.stype?.split('_')?.[1] !== 'aigc')
                                .map((service) => (
                                    <div
                                        key={service.id}
                                        className={`${styles.extra} ${
                                            service.checked && styles.active
                                        }`}
                                    >
                                        <div style={{ position: 'relative' }}>
                                            <div className={styles.name}>{service.sname}</div>
                                            {/* <div className={styles.desc}>
                                                <span className={styles.price}>
                                                    {service.price}元
                                                </span>
                                                <span className={styles.origin}>
                                                    {service.price2}元
                                                </span>
                                            </div> */}
                                        </div>
                                        <Checkbox
                                            disabled={payResult}
                                            style={{ position: 'relative' }}
                                            checked={service.checked}
                                            onChange={(e) => {
                                                summaryStore.onServiceCheck(
                                                    e.target.checked,
                                                    service.stype,
                                                );
                                                summaryStore.getPriceAfterAddServices();
                                            }}
                                        />
                                    </div>
                                ))}
                        </div>
                    </Spin>
                ) : null}
                <div className="relative">
                    {/* 客服二维码 */}
                    <div
                        className={`flex w-full flex-col items-center transition-all duration-300 ${
                            payResult && generateFinish
                                ? 'visible opacity-100'
                                : 'invisible absolute left-0 top-0 opacity-0'
                        }`}
                    >
                        <img width="120" height="120" src={kf} />
                        <div className={'mt-2 pb-3 text-sm text-[#414C6F]'}>
                            全文还未生成？扫码联系客服
                        </div>
                    </div>

                    {/* 倒计时进度条 */}
                    <div
                        className={`transition-all duration-300 ${
                            payResult && !generateFinish
                                ? 'visible opacity-100'
                                : 'invisible absolute left-0 top-0 opacity-0'
                        }`}
                    >
                        <CountdownProgress timeLeft={timeLeft} progress={progress} />
                    </div>
                </div>
            </>
        );
    });

    const isShowExtra = true;
    // summaryStore.docType !== DocType.PROPOSAL_REPORT &&
    // summaryStore.docType !== DocType.LITERATURE_REVIEW;

    return (
        <>
            <Layout
                style={{
                    backgroundColor: '#fff',
                    marginTop: 12,
                }}
            >
                {isMobile ? null : (
                    <Sider
                        width={'18%'}
                        collapsible
                        collapsed={collapsed}
                        trigger={null}
                        collapsedWidth={0}
                        style={{
                            ...siderStyle,
                            left: 0,
                            top: 56,
                            padding: 12,
                            borderRight: '1px solid #EEEEF1',
                            overflow: 'initial',
                            '&::WebkitScrollbar': {
                                width: '0px',
                            },
                            msOverflowStyle: 'none',
                            scrollbarWidth: 'none',
                        }}
                    >
                        <div className={'h-full overflow-y-scroll'}>
                            {summaryStore.catalogueDataLoaded && !collapsed ? <Catalogue /> : null}
                            {/* 展开/收起按钮 */}
                            <div style={toggleButtonStyle} onClick={toggleCollapsed}>
                                {collapsed ? <RightOutlined /> : <LeftOutlined />}
                            </div>
                        </div>
                    </Sider>
                )}
                <Content>
                    <div className={styles.result}>
                        <div className={styles.resultPage}>
                            {isMobile ? (
                                <div
                                    className={'flex items-center'}
                                    onClick={() => {
                                        setMobileCatalogueOpen(!mobileCatalogueOpen);
                                    }}
                                >
                                    {mobileCatalogueOpen ? (
                                        <MenuUnfoldOutlined />
                                    ) : (
                                        <MenuFoldOutlined />
                                    )}
                                    <span>目录</span>
                                </div>
                            ) : null}
                            {/* 标题部分 */}
                            <div className={styles.pageTitle}>{paper?.data?.title}</div>

                            {/* 中文摘要 */}
                            <div>
                                <div className={styles.chapterTitle}>中文摘要</div>
                                <div
                                    className={styles.content}
                                    dangerouslySetInnerHTML={{
                                        __html: getHtmlContent(cnAbstracts),
                                    }}
                                />
                            </div>

                            {/* 英文摘要 */}
                            {cnAbstractsCompleted && (
                                <div>
                                    <div className={styles.chapterTitle}>Abstract</div>
                                    <div
                                        className={styles.content}
                                        dangerouslySetInnerHTML={{
                                            __html: getHtmlContent(enAbstracts),
                                        }}
                                    />
                                </div>
                            )}

                            {/* 继续预览内容 */}
                            {summaryStore.hasPreviewEnd && enAbstractsCompleted && (
                                <>
                                    {/* <div className={styles.pageTitle}> */}
                                    <div className={styles.chapterTitle}>
                                        {paper?.list?.[0]?.chapter}
                                    </div>
                                    <div>
                                        <div
                                            className={styles.chapterTitle}
                                            style={{
                                                textAlign: 'left',
                                            }}
                                        >
                                            {paper?.list?.[0]?.section}
                                        </div>
                                        {/*<div className={styles.content}>*/}
                                        {/*    {paper?.list?.[0]?.content}*/}
                                        {/*</div>*/}
                                        <div
                                            className={styles.content}
                                            dangerouslySetInnerHTML={{
                                                __html: paper?.list?.[0]?.content?.replace(
                                                    /\[\[citation:(\d+)\]\]/g,
                                                    (match, num) => `<sup>[${num}]</sup>`,
                                                ),
                                            }}
                                        />
                                    </div>
                                </>
                            )}

                            {/* 加载提示 */}
                            {(summaryStore.nextPreviewLoading ||
                                cnStreamLoading ||
                                enStreamLoading) && (
                                <Spin tip="生成中" style={{ margin: '0 auto' }}>
                                    <div
                                        style={{
                                            height: '160px',
                                            width: '100%',
                                        }}
                                    />
                                </Spin>
                            )}

                            {/* 支付/下载区域 */}
                            <div className={styles.payButtonBox}>
                                <div className={styles.payMask} />
                                <AiGenTip />
                                <div>
                                    {payResult ? (
                                        // 已支付状态
                                        <div className="flex justify-center gap-2">
                                            <Button
                                                onClick={showOrderModal}
                                                type="primary"
                                                size="large"
                                                shape="round"
                                            >
                                                下载全文
                                            </Button>
                                            {/*<Button*/}
                                            {/*    onClick={goStep4}*/}
                                            {/*    type="primary"*/}
                                            {/*    size="large"*/}
                                            {/*    shape="round"*/}
                                            {/*>*/}
                                            {/*    前往编辑*/}
                                            {/*</Button>*/}
                                        </div>
                                    ) : selectedEntitlement && selectedEntitlement.codeType !== 1 ? (
                                        <div className="mx-auto flex max-w-lg flex-col items-center gap-3 rounded-xl border border-primary/20 bg-white p-5">
                                            <div className="font-medium text-primary">已选择：{selectedEntitlement.redeemName}</div>
                                            <div className="text-center text-sm text-gray-500">{isAmountEntitlement(selectedEntitlement) ? '按当前订单金额兑换，确认时核验兑换码额度。' : '确认套餐内容后生成全文，无需再次支付。'}</div>
                                            <Checkbox checked={summaryStore.isCheckConfirm} onChange={(e) => summaryStore.setIsCheckConfirm(e.target.checked)}>
                                                我已阅读并同意 <a href="/agreement" target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>《服务条款》</a>
                                            </Checkbox>
                                            <Button type="primary" size="large" loading={summaryStore.isExtraloading} disabled={!cnAbstractsCompleted || !enAbstractsCompleted} onClick={unlockAllChapter}>{isAmountEntitlement(selectedEntitlement) ? '使用金额兑换码生成' : '使用已购套餐生成'}</Button>
                                            <Button type="link" onClick={() => usePackageOrders.show({ onSelect: selectPackageEntitlement })}>更换套餐</Button>
                                        </div>
                                    ) : (
                                        // 未支付状态
                                        cnAbstractsCompleted &&
                                        enAbstractsCompleted && (
                                            <div className="flex flex-col">
                                                <div className="flex justify-center">
                                                    {/* 继续预览按钮 */}
                                                    {!summaryStore.hasPreviewEnd && (
                                                        <Space
                                                            direction={
                                                                isMobile ? 'vertical' : 'horizontal'
                                                            }
                                                        >
                                                            <Button
                                                                loading={
                                                                    summaryStore.nextPreviewLoading
                                                                }
                                                                size="large"
                                                                shape="round"
                                                                onClick={handleContinuePreview}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    marginRight: '10px',
                                                                    width: '160px',
                                                                }}
                                                            >
                                                                免费继续预览
                                                            </Button>
                                                            <Button
                                                                loading={
                                                                    summaryStore.nextPreviewLoading
                                                                }
                                                                type="primary"
                                                                size="large"
                                                                shape="round"
                                                                onClick={unlockAllChapter}
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    marginRight: '10px',
                                                                    width: '160px',
                                                                }}
                                                            >
                                                                解锁全篇
                                                            </Button>
                                                        </Space>
                                                    )}
                                                    {/* 支付按钮，预览完成时显示 */}
                                                    {summaryStore.hasPreviewEnd &&
                                                    enAbstractsCompleted &&
                                                    cnAbstractsCompleted ? (
                                                        <Space.Compact
                                                            direction={
                                                                isMobile ? 'vertical' : 'horizontal'
                                                            }
                                                        >
                                                            <Button
                                                                type="primary"
                                                                loading={
                                                                    loading ||
                                                                    summaryStore.isExtraloading
                                                                }
                                                                onClick={() => {
                                                                    unlockAllChapter();
                                                                    // handlePay(1);
                                                                }}
                                                                size="large"
                                                                shape="round"
                                                                style={{
                                                                    height: '56px',
                                                                }}
                                                            >
                                                                <div>解锁全篇</div>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'center',
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            fontSize: '16px',
                                                                            color: '#FFE924',
                                                                        }}
                                                                    >
                                                                        ￥
                                                                        {
                                                                            summaryStore.paperInfo
                                                                                ?.prices
                                                                                ?.totalDiscountedPrice
                                                                        }
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            fontSize: '12px',
                                                                            textDecoration:
                                                                                'line-through',
                                                                            color: 'rgba(255,255,255,0.65)',
                                                                        }}
                                                                    >
                                                                        ￥
                                                                        {
                                                                            summaryStore.paperInfo
                                                                                ?.prices
                                                                                ?.totalOriginalPrice
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </Button>
                                                            {/* <Button
                                                                type="primary"
                                                                loading={
                                                                    loading ||
                                                                    summaryStore.isExtraloading
                                                                }
                                                                onClick={unlockAnyChapter}
                                                                size="large"
                                                                shape="round"
                                                                style={{
                                                                    height: '56px',
                                                                }}
                                                            >
                                                                <div>解锁任意单章正文</div>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        alignItems: 'center',
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            fontSize: '16px',
                                                                            color: '#FFE924',
                                                                        }}
                                                                    >
                                                                        ￥9.90
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            fontSize: '12px',
                                                                            textDecoration:
                                                                                'line-through',
                                                                            color: 'rgba(255,255,255,0.65)',
                                                                        }}
                                                                    >
                                                                        ￥{(9.9 * 1.5).toFixed(2)}
                                                                    </div>
                                                                </div>
                                                            </Button> */}
                                                        </Space.Compact>
                                                    ) : null}
                                                </div>
                                                <div className={'mt-4 flex justify-center'}>
                                                    <Checkbox
                                                        checked={summaryStore.isCheckConfirm}
                                                        onChange={(e) => {
                                                            summaryStore.setIsCheckConfirm(
                                                                e.target.checked,
                                                            );
                                                        }}
                                                    ></Checkbox>
                                                    <div
                                                        className={
                                                            'ml-2 flex cursor-pointer items-center text-[#414C6F]'
                                                        }
                                                        onClick={() => {
                                                            summaryStore.setIsCheckConfirm(
                                                                !summaryStore.isCheckConfirm,
                                                            );
                                                        }}
                                                    >
                                                        我已阅读并同意{' '}
                                                        <a
                                                            style={{ color: '#666' }}
                                                            href={`${window.location.protocol}//${window.location.host}/agreement`}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            《服务条款》
                                                        </a>
                                                    </div>
                                                </div>
                                                {/* 格修改提示 */}
                                                <div className="flex justify-center">
                                                    <div
                                                        style={{
                                                            color: '#999',
                                                            fontSize: '12px',
                                                            marginTop: '8px',
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={showDrawer}
                                                    >
                                                        价格太贵？点击修改图表
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>

                            {cnAbstractsCompleted && enAbstractsCompleted && !payResult && (
                                <div className={styles.payTip} style={{ margin: '0 auto' }}>
                                    <div
                                        style={{
                                            color: '#999',
                                            fontSize: '12px',
                                            marginTop: '8px',
                                            cursor: 'pointer',
                                            textAlign: 'center',
                                        }}
                                        onClick={showCodeModal}
                                    >
                                        使用已购套餐 / 旧兑换码
                                    </div>
                                </div>
                            )}
                            {/* 兑换码入口 */}
                        </div>
                    </div>
                </Content>
                {!isMobile && (
                    <Sider
                        width={'18%'}
                        style={{
                            ...siderStyle,
                            right: 0,
                            top: 68,
                            border: '1px solid #EEEEF1',
                            borderRadius: 12,
                            padding: 16,
                            height: 'calc(100vh - 80px)',
                        }}
                    >
                        <ExtraContent />
                    </Sider>
                )}
                {isMobile && (
                    <div className={'m-3 rounded-xl border border-[#EEEEF1] bg-white p-4'}>
                        <ExtraContent />
                    </div>
                )}
            </Layout>

            <Modal
                open={mobileCatalogueOpen}
                onCancel={() => {
                    setMobileCatalogueOpen(false);
                }}
                onOk={() => {
                    setMobileCatalogueOpen(false);
                }}
            >
                <Spin spinning={!summaryStore.catalogueDataLoaded}>
                    <Catalogue />
                </Spin>
            </Modal>
        </>
    );
});
export default Step3;
